import ProgressItemV2 from "./progress-item-v2"

export default ProgressItemV2
